module.exports = __webpack_public_path__ + "img/tool_icon_4.fabce30.png";